/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { globalConfig } from '../config/config';
import { prefixPath } from './helpers';

class BaseUrls {
  static _getKeyValue_ = (key: string) => (obj: Record<string, any>) => obj[key];

  static getApplicationBackendUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.endpoints.baseUrl;
          break;
        }
      }
    }
    return url;
  }

  static getInappNotificationsUrl(token: string): string {
    let url = '';
    if (globalConfig.config) {
      url = globalConfig.config.InAppNotificationUrl;
      url = `${url}?token=${token}`;
      return url;
    }
    return url;
  }

  static getAuthUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.endpoints.authUrl;
          break;
        }
      }
    }
    return url;
  }

  static getAllPlanUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.redirections.allPlan;
          break;
        }
      }
    }
    return url;
  }

  static getplanCalculatorUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.redirections.planCalculator;
          break;
        }
      }
    }
    return url;
  }

  static getDocUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.redirections.docs;
          break;
        }
      }
    }
    return url;
  }

  static getContactDetails(): { email: string, helpdeskURL: string } {
    const loc = window.location.hostname;
    let email = '';
    let helpdeskURL = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          email = obj.contacts.email;
          helpdeskURL = obj.contacts.helpdeskURL;
          break;
        }
      }
    }
    return {
      email, helpdeskURL,
    };
  }

  static getAlertsBackendUrl(): string {
    const loc = window.location.hostname;
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          url = obj.endpoints.alertsBackendUrl;
          break;
        }
      }
    }
    return url;
  }

  static getMarketplaceUrl(): string {
    const loc = window.location.hostname;
    const marketPlaceSource = localStorage.getItem('market_place_source');
    let url = '';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          if (obj.single_protocol) {
            url = `${obj.single_protocol_url}purchase`;
          } else if (marketPlaceSource === 'marketplace') {
            url = `${prefixPath('/marketplace')}`;
          } else if (marketPlaceSource === 'staking-nodes') {
            url = `${prefixPath('/marketplace/staking-nodes')}`;
          } else {
            url = `${prefixPath('/marketplace')}`;
          }
          break;
        }
      }
    }
    return url;
  }

  static getkey(): string {
    const loc = window.location.hostname;
    let theme = 'zeeve';
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          theme = key;
          break;
        }
      }
    }
    return theme;
  }

  static sharedApiEnabled(): boolean {
    const loc = window.location.hostname;
    let isSharedApiEnabled = true;
    if (globalConfig.config) {
      for (const key in globalConfig.config.multi_tenant_domains) {
        const obj = this._getKeyValue_(key)(globalConfig.config.multi_tenant_domains);
        if (loc === obj.domain) {
          isSharedApiEnabled = obj.sharedApi;
          break;
        }
      }
    }
    return isSharedApiEnabled;
  }

  static getPlatformDashboardUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${config.appFrontendUrl}/dashboard`;
    }
    return url;
  }

  // New Platform Full Nodes page
  static getPlatformDedicatedFullNodesUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      const domainName = config.platformFrontendUrl; // Needs improvisation by integrating new platform url in config
      url = `${domainName}/manage/nodes/full`;
    }
    return url;
  }

  static getPlatformManageDedicatedNodesUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${config.appFrontendUrl}/allNetwork`;
    }
    return url;
  }

  // New Platform Validator Nodes page
  static getPlatformDedicatedValidatorNodesUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      const domainName = config.platformFrontendUrl; // Needs improvisation by adding new platform url in config
      url = `${domainName}/manage/nodes/validator`;
    }
    return url;
  }

  static getPlatformManageStakingNodesUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${config.appFrontendUrl}/network/staking-nodes`;
    }
    return url;
  }

  static getPlatformWorkspaceUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${config.appFrontendUrl}/workspace`;
    }
    return url;
  }

  static getNetworkDetails(id: string | number): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}network-node/${id}`;
      return url;
    }
    return url;
  }

  static getAllNodes(id: string | number): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}network-node/${id}/nodes`;
      return url;
    }
    return url;
  }

  static getNodeCloud(nodeId: string | number): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}cloud/node/${nodeId}`;
      return url;
    }
    return url;
  }

  static getNodeInfoUrl(id: string | number, nodeId: string): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}networks/${id}/nodes/${nodeId}/status`;
      return url;
    }
    return url;
  }

  static deleteNetworkById(networkId: string | number): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}networks/${networkId}`;
      return url;
    }
    return url;
  }

  static deleteNodeById(id: string | number, nodeId: string): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}networks/${id}/nodes/${nodeId}`;
      return url;
    }
    return url;
  }

  static getCloudRegion(couldId: string | number): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}cloud/regions/${couldId}`;
      return url;
    }
    return url;
  }

  static getRpcDetails(id: string | number, nodeId: string): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}networks/${id}/nodes/${nodeId}`;
      return url;
    }
    return url;
  }

  static registerUserCommunicationChannel(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}communicationChannel/register`;
      return url;
    }
    return url;
  }

  static getUserCommunicationChannel(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}communicationChannel/all`;
      return url;
    }
    return url;
  }

  static editUserCommunicationChannel(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}communicationChannel/edit`;
      return url;
    }
    return url;
  }

  static testUserCommunicationChannelNotification(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}communicationChannel/test`;
      return url;
    }
    return url;
  }

  static deleteUserCommunicationChannel(channelId: string): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = `${this.getApplicationBackendUrl()}communicationChannel/channel/${channelId}`;
      return url;
    }
    return url;
  }

  static getSidebarModuleUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.module.sidebar;
    }
    return url;
  }
}
export default BaseUrls;